import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { DashboardComponent } from './layouts/dashboard/dashboard.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { LeftNavigationComponent } from './shared/components/left-navigation/left-navigation.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from './core/core.module';
import { ButtonModule, CheckBoxModule, RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { enableRipple } from '@syncfusion/ej2-base';
import { AccordionAllModule, AccordionModule, SidebarModule, TabModule, TreeViewModule, ToolbarModule, MenuModule } from '@syncfusion/ej2-angular-navigations';
import { GridModule, PageService, SortService, FilterService, GroupService } from '@syncfusion/ej2-angular-grids';
import { DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { TooltipModule, DialogModule } from '@syncfusion/ej2-angular-popups';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { DatePipe } from '@angular/common';
import { IncidentReportFileModule } from './modules/IncidentReportFile/incident-report-file.module';
import { AppConfigService, ConfigFactory, API_BASE_URL, GOOGLE_RECAPTCHA_SITE_KEY, REDIRECT_URI, UNIVERSAL_INTAKE_URL, VERSION } from './core/services/appConfig/app-config.service';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ListViewModule } from '@syncfusion/ej2-angular-lists';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from '@syncfusion/ej2-angular-notifications';
import { DatePickerModule, DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ScriptService } from 'ngx-captcha';
import { GlobalErrorHandler } from './core/services/GlobalException/GlobalErrorHandler';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as featureState from './store/state/features/feature.reducers';
import { FeatureEffects } from './store/state/features/feature.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { UserEffects, user } from './store/state/user';
import { ConstantsEffects, constantsReducer } from './store/state/constants';
import { loadingReducer } from './store/state/loading/loading.reducers';
import { SharedModule } from './shared/shared.module';
enableRipple(true);

@NgModule({ declarations: [
        AppComponent,
        AuthLayoutComponent,
        DashboardComponent,
        HeaderComponent,
        LeftNavigationComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        ButtonModule,
        SidebarModule,
        TreeViewModule,
        GridModule,
        ToolbarModule,
        MenuModule,
        DropDownButtonModule,
        TextBoxModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            timeOut: 3000,
            preventDuplicates: true,
            progressBar: true,
            closeButton: true
        }),
        RadioButtonModule,
        AccordionModule,
        AccordionAllModule,
        TooltipModule,
        RichTextEditorAllModule,
        DialogModule,
        TabModule,
        DropDownListModule,
        CheckBoxModule,
        ListViewModule,
        IncidentReportFileModule,
        BrowserAnimationsModule,
        ToastModule,
        DatePickerModule,
        DateRangePickerModule,
        StoreModule.forRoot({
            user: user.reducers,
            constants: constantsReducer,
            loading: loadingReducer,
            [featureState.featureKey]: featureState.reducers
        }),
        EffectsModule.forRoot([UserEffects, ConstantsEffects, FeatureEffects]),
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production, connectInZone: true })], providers: [
        AppConfigService,
        { provide: 'CONFIGPATH', useValue: 'appconfig.json' },
        { provide: 'APIURL-VAR', useValue: 'API_BASE_URL' },
        { provide: 'GOOGLE_RECAPTCHA_SITE_KEY-VAR', useValue: 'GOOGLE_RECAPTCHA_SITE_KEY' },
        { provide: 'REDIRECT_URI-VAR', useValue: 'REDIRECT_URI' },
        { provide: 'UNIVERSAL_INTAKE_URL-VAR', useValue: 'UNIVERSAL_INTAKE_URL' },
        { provide: 'VERSION', useValue: 'VERSION' },
        {
            provide: API_BASE_URL, useFactory: ConfigFactory,
            deps: [AppConfigService, 'CONFIGPATH', 'APIURL-VAR']
        },
        {
            provide: GOOGLE_RECAPTCHA_SITE_KEY, useFactory: ConfigFactory,
            deps: [AppConfigService, 'CONFIGPATH', 'GOOGLE_RECAPTCHA_SITE_KEY-VAR']
        },
        {
            provide: REDIRECT_URI, useFactory: ConfigFactory,
            deps: [AppConfigService, 'CONFIGPATH', 'REDIRECT_URI-VAR']
        },
        {
            provide: UNIVERSAL_INTAKE_URL, useFactory: ConfigFactory,
            deps: [AppConfigService, 'CONFIGPATH', 'UNIVERSAL_INTAKE_URL-VAR']
        },
        {
            provide: VERSION, useFactory: ConfigFactory,
            deps: [AppConfigService, 'CONFIGPATH', 'VERSION']
        },
        {
            provide: ErrorHandler, useClass: GlobalErrorHandler
        },
        PageService,
        SortService,
        FilterService,
        GroupService,
        ScriptService,
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
